import React from 'react';
import { DateTime } from 'luxon';

function TableDate({ date }) {
  return DateTime.fromISO(date).toLocaleString({
    month: '2-digit',
    day: '2-digit',
    year: '2-digit',
  });
}

export default React.memo(TableDate);
